export default __webpack_public_path__ + "static/cafe_36013-c18a005d8d580f2b49d64ca77d95b615.png";